<template>
	<div>
		Admin Page!
		<form method="post" @submit.prevent="onSubmit">
			<!-- Change Rounds, Current Round, and Picking Order stuff -->
			<p>
				<label for="rounds">Rounds:</label>
				<input id="rounds" v-model="rounds" type="text" />
			</p>
			<draggable
				v-model="picking_order"
				@start="drag = true"
				@end="drag = false"
			>
				<div v-for="user in picking_order" :key="user.id">
					{{ user.name }}
				</div>
			</draggable>
			<input type="submit" />
		</form>
	</div>
</template>

<script>
import apiClient from '@/plugins/apiClient';
import draggable from 'vuedraggable';

export default {
	name: 'Admin',
	components: {
		draggable,
	},
	data() {
		return {
			rounds: null,
			picking_order: [],
		};
	},
	created() {
		let component = this;
		const room_id = this.$route.params.room_id;

		apiClient
			.get('api/v1/rooms/' + room_id + '/settings')
			.then(({ data }) => {
				component.picking_order = data.picking_order;
			});
	},
	methods: {
		calculatePickingOrder() {
			this.picking_order.forEach((user, index) => {
				user.picking_order = index;
			});
		},
		onSubmit() {
			// let component = this;
			const room_id = this.$route.params.room_id;

			this.calculatePickingOrder();

			const params = {
				rounds: this.rounds,
				picking_order: this.picking_order,
			};
			// Will need to include a flag to bypass this when entering a room
			apiClient
				.post(
					'api/v1/rooms/' + room_id + '/set_settings',
					params,
					{}
				)
				.then(response => {
					console.log(response);
				});
		},
	},
};
</script>

<style scoped>
.picking-order {
	background-color: #eee;
	margin-bottom: 10px;
	padding: 10px;
}

.draggable-el {
	background-color: #fff;
	margin-bottom: 10px;
	padding: 5px;
}
</style>
